const rawApiBase =
  import.meta.env.VITE_BASE_API ??
  import.meta.env.VITE_API_BASE ??
  import.meta.env.VITE_API_BASE_URL ??
  "https://level-henderson-attraction-teachers.trycloudflare.com";

// убираем хвостовой /
export const API_BASE = rawApiBase.replace(/\/$/, "");

/**
 * Если API_BASE пустой — возвращаем относительный path,
 * чтобы работал vite proxy (/users -> localhost:5210).
 * Если API_BASE задан — делаем абсолютный URL.
 */
export function withApiBase(path) {
  if (!API_BASE) return path;
  return `${API_BASE}${path}`;
}
